
import './index.less'
import React, { useState } from 'react'

export default function UploadPictures(props) {
  const [ifon, setIfon] = useState({
    fileDom: React.createRef(),
    isUpload: false,
    type: 'file'
  })

  return <div className='uploadPictures' onDragOver={(e) => {
    e.preventDefault()
  }} onDrop={(e) => {
    e.preventDefault()
    uploadPictures1(e, ifon, setIfon, props)
  }} onClick={() => {
    ifon.isUpload || ifon.fileDom.current.click()
  }}>
    {ifon.isUpload

      ? <div className='uploadPictures_tips'>
        <img className='tips_img' src='https://wimg.588ku.com/gif620/21/05/17/31ada1a9c7f478b1a3a0ea2d793039a6.gif' />
        <span className='tips_text'>上传中...</span>
      </div>

      : <img className='uploadPictures_img' src='https://read.e.qq.com/assets/images/yuebao/icon_upload.png' />}

    <input ref={ifon.fileDom} onChange={(event) => {
      uploadPictures(event, ifon, setIfon, props)
    }} className='file' type={ifon.type} multiple accept='image/gif,image/jpg,image/jpeg,image/png' />
  </div>
}

function uploadPictures(e, ifon, setIfon, props) {
  const fileIfon = e.target.files[0]
  setIfon({
    ...ifon,
    isUpload: true,
    type: 'text'
  })

  const img = new Image()
  img.onload = (en) => {
    props.change && props.change({ size: fileIfon.size, width: img.width, height: img.height, file: fileIfon }, () => {
      setIfon({
        ...ifon,
        isUpload: false,
        type: 'file'
      })
    })

    img.remove()
  }
  img.src = window.URL.createObjectURL(fileIfon)
}

function uploadPictures1(e, ifon, setIfon, props) {
  const fileIfon = e.dataTransfer.files[0]
  setIfon({
    ...ifon,
    isUpload: true
  })

  const img = new Image()

  img.onload = (en) => {
    props.change && props.change({ size: fileIfon.size, width: img.width, height: img.height, file: fileIfon }, () => {
      setIfon({
        ...ifon,
        isUpload: false
      })
    })

    img.remove()
  }
  img.src = window.URL.createObjectURL(fileIfon)
}
